import { dataUrl } from "../common";

// Helper function to generate BlogPosting schema data
export const generateBlogPostingSchema = (blogData) => {
  if (!blogData || !blogData.name) return null;

  // Clean HTML content for description
  const cleanContent = (content) => {
    if (!content) return '';
    // Remove HTML tags and decode entities
    return content
      .replace(/<[^>]*>/g, '') // Remove HTML tags
      .replace(/&ldquo;/g, '"') // Decode quotes
      .replace(/&rdquo;/g, '"')
      .replace(/&rsquo;/g, "'")
      .replace(/&#39;/g, "'")
      .replace(/&amp;/g, '&')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/\s+/g, ' ') // Replace multiple spaces with single space
      .trim()
      .substring(0, 300); // Limit to 300 characters
  };

  // Get tags array
  const getTags = (tagsString) => {
    if (!tagsString) return [];
    return tagsString.split(',').map(tag => tag.trim()).filter(tag => tag.length > 0);
  };

  const description = cleanContent(blogData.content || blogData.additional_fields?.short_description);
  const tags = getTags(blogData.additional_fields?.tags);

  const imageUrl = blogData.additional_fields?.image ? 
    `${dataUrl}/contents/${blogData.additional_fields.image}` : 
    `${dataUrl}/assets/images/webvi-logo.png`;

  return {
    title: blogData.name,
    description: description,
    datePublished: blogData.created_at ? new Date(blogData.created_at).toISOString() : new Date().toISOString(),
    dateModified: blogData.updated_at ? new Date(blogData.updated_at).toISOString() : new Date().toISOString(),
    author: {
      name: 'JobSeekers Page',
      url: window.location.origin
    },
    publisher: {
      name: 'JobSeekers Page',
      url: window.location.origin,
      logo: {
        url: `${window.location.origin}/assets/images/webvi-logo.png`
      }
    },
    image: imageUrl,
    url: `${window.location.origin}/blogs/${blogData.id}/${blogData.name?.toLowerCase().replace(/\s+/g, '-')}`,
    keywords: tags.join(', '),
    articleSection: 'Career Advice',
    mainEntityOfPage: {
      url: `${window.location.origin}/blogs/${blogData.id}/${blogData.name?.toLowerCase().replace(/\s+/g, '-')}`
    }
  };
};

// Helper function to generate Blog schema for blog listings page
export const generateBlogListingsSchema = () => {
  return {
    title: "JobSeekers Page Blog",
    description: "Latest articles, career tips, hiring insights, and industry news from JobSeekers Page.",
    url: `${window.location.origin}/blogs`,
    publisher: {
      name: 'JobSeeker Page',
      url: window.location.origin,
      logo: {
        url: `${window.location.origin}/assets/images/webvi-logo.png`
      }
    },
    mainEntity: {
      url: `${window.location.origin}/blogs`
    }
  };
}; 